import Vue from 'vue';

import TreeMenu from '@/components/TreeMenu';
Vue.component('TreeMenu', TreeMenu);

import Picture from '@/components/Picture';
Vue.component('Picture', Picture);

import Spinner from '@/components/Spinner';
Vue.component('Spinner', Spinner);

import Error from '@/components/Error';
Vue.component('Error', Error);

import VuePhotoSwipe from '@/plugins/PhotoSwipe';
Vue.use(VuePhotoSwipe);
